<template>
  <div style="padding:16px 0">
    <table border="0">
      <tr>
        <td>
          <a :href="link" target="_blank"><img :src="$assetUrl('1pc_ftp.png')" style="width:30px;" /></a>
        </td>
        <td rowspan="2" style="text-align:left;padding-left:10px;font-size:14px;line-height:20px;">
          P.S. Through our initiative to try and plant 10 million trees, each commission gives life
          to an average of 60 trees through our planting partners at 
          <a :href="link" style="color:#7a7157" target="_blank">Weforest</a> and membership 
          of <a :href="link" style="color:#7a7157" target="_blank">1% for the Planet</a>.<br>
          <strong>{{ getCount() }} trees to date.</strong> More info <a :href="link" style="color:#7a7157" target="_blank">here</a>.
        </td>
      </tr>
      <tr>
        <td>
          <a :href="$host + '/ten-million-trees' + cclink" target="_blank"><img :src="$assetUrl('weforest.png')" style="width:60px;" /></a>
        </td>
      </tr>
      <tr>
        <td>
          <a :href="link" target="_blank"><img :src="$assetUrl('b-corp.png')" style="width:40px;" /></a>
        </td>
        <td style="text-align:left;padding-left:10px;font-size:14px;line-height:20px;">
          We are proud to be a BCorp, joining a global community of businesses measuring
          our social and environmental impact. <br>More info <a :href="link" style="color:#7a7157" target="_blank">here</a>.
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import tc from 'illusx-trees'
export default {
  props: {
    cclink: String
  },
  computed: {
    link () {
      return this.$host + '/our-values' + this.cclink
    }
  },
  methods: {
    getCount() {
      return tc.countTrees().toLocaleString()
    }
  }
}
</script>

<style>

</style>